import type { DisciplineState } from '@features/instructors/api/types/instructor.types';

import type { DisciplineActionConfig } from './DisciplineAction.types';

export const DISCIPLINE_ACTION_CONFIG: Partial<
  Record<DisciplineState, DisciplineActionConfig>
> = {
  Approved: { variant: 'ghost-danger', label: 'Revoke' },
  Unapproved: { variant: 'ghost', label: 'Approve' },
  Pending: { variant: 'ghost', label: 'Cancel approval' },
  PendingRemoval: { variant: 'ghost', label: 'Cancel revocation' },
  PendingApprovalLetter: { variant: 'ghost', label: 'Upload letter' },
};
